export default "__VITE_ASSET__BPRWStRH__"